import { render, staticRenderFns } from "./TalkizyDisconnectSection.vue?vue&type=template&id=d2d6eb34&"
import script from "./TalkizyDisconnectSection.vue?vue&type=script&lang=js&"
export * from "./TalkizyDisconnectSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports